export enum AppConst {
	ACCESS_TOKEN = 'ACCESS_TOKEN',
	USER_DATA = 'USER_DATA',
}
